var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"dashboard",attrs:{"datePickerRange":_vm.datePickerRange,"studios":_vm.studios,"selectedStudioSingle":_vm.selectedStudioSingle}})
}
var staticRenderFns = []

export { render, staticRenderFns }